import { Modal } from "react-bootstrap";import React from "react";

const DotLottieReact = React.lazy(() =>
  import("@lottiefiles/dotlottie-react").then(module => ({
    default: module.DotLottieReact,
  }))
);

import { useDispatch, useSelector } from "react-redux";
import { setTickModelFalse } from "../../store/slices/modalSlice";
import { useEffect } from "react";

const TickModel = () => {
  const dispatch = useDispatch();

  const showTickModel = useSelector(
    (state: { modal: { tickModel: boolean } }) => state.modal.tickModel
  );
  useEffect(() => {
    setTimeout(() => {
      dispatch(setTickModelFalse());
    }, 3000);
  }, []);

  return (
    <div>
      <Modal
        centered
        show={showTickModel}
        onHide={() => dispatch(setTickModelFalse())}
        className="mb-fix modal-sm"
      >
        <Modal.Body className="rounded scanning-main">
          <div className="done-check visible">
            <DotLottieReact
              src="https://lottie.host/7a962458-bb58-4acd-ae34-c8521f1f928e/6eeOKQV9tx.lottie"
              loop
              autoplay
              style={{ width: "150px", height: "150px" }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TickModel;
